import { render, staticRenderFns } from "./RegisterBenefits.vue?vue&type=template&id=51984f8c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default})
